import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  TComponentTagWipInfoRequestDTO,
  TComponentTagWipInfoResponseDTO,
  TTransactionDetailsRequestDTO,
  TAssemblyInComponentsGroupAddResponseDTO,
  TAssemblyInComponentsGroupAddRequestDTO,
  TAssemblyInTransactionResponse,
  TAssemblyInTransactionRequest,
  TAssemblyInTransactionDetailsResponse,
  TAssemblyInComponentGroupUndoRequestDTO,
  TAssemblyInComponentGroupUndoResponseDTO,
  TAssemblyInBundleTransactionResponse,
  TAssemblyInBundleTransactionRequest,
  TAssemblyInBundleTransactionDetailsResponse,
  TAssemblyInBundleTransactionDetailsRequest,
  TComponentTagProcessHistoryRequestDTO,
  TComponentTagProcessHistoryResponseDTO,
  TUndoBundleTagResponse,
  TUndoBundleTagRequest,
  TComponentTagsWipInfoByBundleTagResponseDTO,
  TComponentTagsWipInfoByBundleTagRequestDTO,
} from '@monorepo/types';

import { AssemblyInEnvProvider } from './assembly-in.env.provider';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class AssemblyInDataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private assemblyInEnvProvider: AssemblyInEnvProvider) {}

  fetchComponentTagWipInfo(payload: TComponentTagWipInfoRequestDTO): Observable<TComponentTagWipInfoResponseDTO> {
    const URL = this.assemblyInEnvProvider.getEnvVar('FETCH_COMPONENT_TAG_WIP_INFO');
    return this.http.post<TComponentTagWipInfoResponseDTO>(URL, payload, this.httpOptions);
  }

  saveComponentTags(
    payload: TAssemblyInComponentsGroupAddRequestDTO,
  ): Observable<TAssemblyInComponentsGroupAddResponseDTO> {
    const URL = this.assemblyInEnvProvider.getEnvVar('SAVE_COMPONENT_TAGS');
    return this.http.post<TAssemblyInComponentsGroupAddResponseDTO>(URL, payload, this.httpOptions);
  }

  fetchTransactionLog(payload: TAssemblyInTransactionRequest): Observable<TAssemblyInTransactionResponse> {
    const URL = this.assemblyInEnvProvider.getEnvVar('FETCH_TRANSACTION_LOG');
    return this.http.post<TAssemblyInTransactionResponse>(URL, payload, this.httpOptions);
  }

  getTransactionDetails(payload: TTransactionDetailsRequestDTO): Observable<TAssemblyInTransactionDetailsResponse> {
    const URL = this.assemblyInEnvProvider.getEnvVar('TRANSACTION_DETAILS');
    return this.http.post<TAssemblyInTransactionDetailsResponse>(URL, payload, this.httpOptions);
  }

  undoComponentTags(
    payload: TAssemblyInComponentGroupUndoRequestDTO,
  ): Observable<TAssemblyInComponentGroupUndoResponseDTO> {
    const URL = this.assemblyInEnvProvider.getEnvVar('UNDO_COMPONENT_TAGS');
    return this.http.post<TAssemblyInComponentGroupUndoResponseDTO>(URL, payload, this.httpOptions);
  }

  fetchBundleTransactionLog(
    payload: TAssemblyInBundleTransactionRequest,
  ): Observable<TAssemblyInBundleTransactionResponse> {
    const URL = this.assemblyInEnvProvider.getEnvVar('FETCH_BUNDLE_TRANSACTION_LOG');
    return this.http.post<TAssemblyInBundleTransactionResponse>(URL, payload, this.httpOptions);
  }

  fetchBundleTransactionDetails(
    payload: TAssemblyInBundleTransactionDetailsRequest,
  ): Observable<TAssemblyInBundleTransactionDetailsResponse> {
    const URL = this.assemblyInEnvProvider.getEnvVar('BUNDLE_TRANSACTION_DETAILS');
    return this.http.post<TAssemblyInBundleTransactionDetailsResponse>(URL, payload, this.httpOptions);
  }

  getComponentTagProcessHistory(
    payload: TComponentTagProcessHistoryRequestDTO,
  ): Observable<TComponentTagProcessHistoryResponseDTO> {
    const URL = this.assemblyInEnvProvider.getEnvVar('GET_COMPONENT_TAG_PROCESS_HISTORY');
    return this.http.post<TComponentTagProcessHistoryResponseDTO>(URL, payload, this.httpOptions);
  }

  undoBundleTag(payload: TUndoBundleTagRequest): Observable<TUndoBundleTagResponse> {
    const URL = this.assemblyInEnvProvider.getEnvVar('BUNDLE_TAG_UNDO');
    return this.http.post<TUndoBundleTagResponse>(URL, payload, this.httpOptions);
  }

  getComponentTagsWipInfoByBundleTag(
    payload: TComponentTagsWipInfoByBundleTagRequestDTO,
  ): Observable<TComponentTagsWipInfoByBundleTagResponseDTO> {
    const URL = this.assemblyInEnvProvider.getEnvVar('FETCH_COMPONENT_TAG_WIP_INFO_BY_MASTER_BUNDLE_TAG');
    return this.http.post<TComponentTagsWipInfoByBundleTagResponseDTO>(URL, payload, this.httpOptions);
  }
}
